import { Component } from '@angular/core';

@Component({
  selector: 'app-recommendations-widget',
  standalone: false,
  templateUrl: './recommendations-widget.component.html',
  styleUrl: './recommendations-widget.component.scss'
})
export class RecommendationsWidgetComponent {

}
